import { render, staticRenderFns } from "./preferentialsales.vue?vue&type=template&id=8515b0a2&scoped=true&"
import script from "./preferentialsales.vue?vue&type=script&lang=js&"
export * from "./preferentialsales.vue?vue&type=script&lang=js&"
import style0 from "./preferentialsales.vue?vue&type=style&index=0&id=8515b0a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8515b0a2",
  null
  
)

export default component.exports